var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloorplans(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.512 5h-16a.5.5 0 00-.5.5v13a.5.5 0 00.5.5h16a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5zm-16-2a2.5 2.5 0 00-2.5 2.5v13a2.5 2.5 0 002.5 2.5h16a2.5 2.5 0 002.5-2.5v-13a2.5 2.5 0 00-2.5-2.5h-16z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#floorplans_svg__clip0_437_14970)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.288 25.367h1.947v-3.23H8.288v3.23zm0-5.385h1.947v-3.23H8.288v3.23zm19.476 5.385h-1.948v-3.23h1.948v3.23zm-1.948-5.385h1.948v-3.23h-1.948v3.23zM21.921 31.83H19v-2.154h2.921v2.154zm-7.79 0h2.921v-2.154h-2.921v2.154zm7.79-19.385H19V10.29h2.921v2.154zm-7.79 0h2.921V10.29h-2.921v2.154zm-1.948 19.384H8.288V27.52h1.947v2.154h1.948v2.154zm0-19.384V10.29H8.288v4.307h1.947v-2.153h1.948zM23.87 31.829v-2.154h1.948V27.52h1.947v4.308H23.87zm1.948-17.232h1.947V10.29H23.87v2.154h1.948v2.153z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "floorplans_svg__clip0_437_14970"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(7.283 10)",
    d: "M0 0h15v11H0z"
  })))));
}
export default __webpack_public_path__ + "media/small/floorplans-d74f7cc3.svg";
export { SvgFloorplans as ReactComponent };